// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2_ChM","footer":"Form_footer__3KU__"};